import React from 'react'
import logo from '../../assets/images/cacti-club-logo.png'
import ConnectButton from '../ConnectButton/ConnectButton'

import { useWallet } from '@binance-chain/bsc-use-wallet'

interface Props {
  onClickCollection: Function
  showCollection: boolean
}

function Menu(props: Props) {
  const wallet = useWallet()

  return (
    <>
      <div id="navbar">
        <div className="container">
          <div className="navbar-header">
            <button type="button" className="nav-toggle nav-trigger">
              <div className="nav-icon">
                <span></span>
              </div>
            </button>
            <a className="logo-main-mob" href="/">
              <span>
                <img src={logo} alt="Cacti Club" />
              </span>
            </a>
            <div className="nav-wrap">
              <nav id="nav-main">
                <ul>
                  <li>
                    <a className="n-link-1" href="https://www.cacticlub.io/#content-1" target='_blank' rel="noreferrer">
                      Story
                    </a>
                  </li>
                  <li>
                    <a className="n-link-2" href="https://www.cacticlub.io/#content-2" target='_blank' rel="noreferrer">
                      Mint Cacti
                    </a>
                  </li>
                  <li>
                    <a className="n-link-3" href="https://www.cacticlub.io/#content-3" target='_blank' rel="noreferrer">
                      The Club
                    </a>
                  </li>
                  <li>
                    <a className="n-link-4" href="https://www.cacticlub.io/#content-4" target='_blank' rel="noreferrer">
                      Mutation
                    </a>
                  </li>
                </ul>
              </nav>
              <a className="logo-main" href="/">
                <span className="logo-main-dark">
                  <img src={logo} alt="Cacti Club" />
                </span>
              </a>
              <nav id="nav-right">
                <ul>
                  <li>
                    <a className="n-link-5" href="https://www.cacticlub.io/#content-5" target='_blank' rel="noreferrer">
                      The team
                    </a>
                  </li>
                  <li>
                    <a className="n-link-6" href="https://www.cacticlub.io/#content-6" target='_blank' rel="noreferrer">
                      Rarity
                    </a>
                  </li>
                  <li>
                    <a className="n-link-7" href="https://www.cacticlub.io/#content-faq" target='_blank' rel="noreferrer">
                      FAQ
                    </a>
                  </li>
					<li><a href="https://staking.cacticlub.io/">Stake</a></li>
                </ul>
                <div className="nav-connect">
                  <ConnectButton enableTextDialog className="button l-btn" />
                  {wallet.account && props.showCollection &&
                    <div className="nav-dropdown" onClick={() => {
                      props.onClickCollection();
                      if (window.innerWidth <= 768) {
                        document.body.classList.remove('menu-open');
                      }
                    }}>
                      <div className="nav-dropdown-item" id='nav-dropdown-item'>
                        Click to view your collection
                      </div>
                    </div>
                  }
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Menu
